module.exports = __webpack_public_path__ + "static/img/huaxiaAL1.b06b372.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/huaxiaAL1.jpg
// module id = 21fo
// module chunks = 0